import React, { useState, useEffect } from "react";
import Joyride, { STATUS } from "react-joyride";
import { steps } from "./steps";
import { getItem, setItem } from "../../utils/local-storage";

const Walkthrough = () => {
  const [run, setRun] = useState(false);

  useEffect(() => {
    const tourSeen = getItem("tour_seen");
    if (!tourSeen) {
      setRun(true);
    }
  }, []);

  const handleJoyrideCallback = (data) => {
    const { status } = data;
    const finishedStatuses = [STATUS.FINISHED, STATUS.SKIPPED];

    if (finishedStatuses.includes(status)) {
      setRun(false);
      setItem("tour_seen", true);
    }
  };

  return (
    <Joyride
      steps={steps}
      run={run}
      continuous
      showSkipButton
      showProgress
      styles={{
        options: {
          zIndex: 10000,
          primaryColor: "#037afb",
        },
      }}
      callback={handleJoyrideCallback}
    />
  );
};

export default Walkthrough;
